import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDataLayout } from "../../data/redux/themeSettingSlice";
import ImageWithBasePath from "../imageWithBasePath";
import {
  setMobileSidebar,
  toggleMiniSidebar,
} from "../../data/redux/sidebarSlice";
import { all_routes } from "../../../feature-module/router/all_routes";
import { useAuth } from "../context/AuthContext";
const Header = () => {
  const routes = all_routes;
  const dispatch = useDispatch();
  const { setToken, isAuthenticated, setIsAuthenticated } = useAuth();
  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);

  const [subOpen, setSubopen] = useState<any>("");
  const [subsidebar, setSubsidebar] = useState("");
  const navigate = useNavigate();

  const toggleSidebar = (title: any) => {
    localStorage.setItem("menuOpened", title);
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };
  const mobileSidebar = useSelector(
    (state: any) => state.sidebarSlice.mobileSidebar,
  );

  const toggleMobileSidebar = () => {
    dispatch(setMobileSidebar(!mobileSidebar));
  };

  const handleToggleMiniSidebar = () => {
    if (dataLayout === "mini_layout") {
      dispatch(setDataLayout("default_layout"));
      localStorage.setItem("dataLayout", "default_layout");
    } else {
      dispatch(toggleMiniSidebar());
    }
  };

  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    if (!isFullscreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen().catch((err) => {});
        setIsFullscreen(true);
      }
    } else {
      if (document.exitFullscreen) {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch((err) => {});
        }
        setIsFullscreen(false);
      }
    }
  };

  //logout
  const handleLogout = () => {
    localStorage.clear();
    // setToken(null);
    // setIsAuthenticated(false);
    setTimeout(() => {
      window.location.href = all_routes.login;
    }, 2000);
  };

  return (
    <>
      {/* Header */}
      <div className="header">
        <div className="main-header">
          <div className="header-left">
            <Link to={routes.adminDashboard} className="logo">
              <ImageWithBasePath
                src="/assets/Nestfin_logo.png"
                alt="Nestfin Logo"
              />
            </Link>
            <Link to={routes.adminDashboard} className="dark-logo">
              <ImageWithBasePath
                src="/assets/Nestfin_logo.png"
                alt="Nestfin Logo"
              />
            </Link>
          </div>

          <Link
            id="mobile_btn"
            onClick={toggleMobileSidebar}
            className="mobile_btn"
            to="#sidebar"
          >
            <span className="bar-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </Link>

          <div className="header-user">
            <div className="nav user-menu nav-list">
              <div
                className="me-auto d-flex align-items-center"
                id="header-search"
              >
                <div className="dropdown crm-dropdown">
                  <div className="dropdown-menu dropdown-lg dropdown-menu-start">
                    <div className="card mb-0 border-0 shadow-none">
                      <div className="card-header">
                        <h4>CRM</h4>
                      </div>
                      <div className="card-body pb-1">
                        <div className="row">
                          <div className="col-sm-6">
                            <Link
                              // to={routes.contactList}
                              to="#"
                              className="d-flex align-items-center justify-content-between p-2 crm-link mb-3"
                            >
                              <span className="d-flex align-items-center me-3">
                                <i className="ti ti-user-shield text-default me-2"></i>
                                Contacts
                              </span>
                              <i className="ti ti-arrow-right"></i>
                            </Link>
                            <Link
                              // to={routes.dealsGrid}
                              to="#"
                              className="d-flex align-items-center justify-content-between p-2 crm-link mb-3"
                            >
                              <span className="d-flex align-items-center me-3">
                                <i className="ti ti-heart-handshake text-default me-2"></i>
                                Deals
                              </span>
                              <i className="ti ti-arrow-right"></i>
                            </Link>
                            <Link
                              // to={routes.pipeline}
                              to="#"
                              className="d-flex align-items-center justify-content-between p-2 crm-link mb-3"
                            >
                              <span className="d-flex align-items-center me-3">
                                <i className="ti ti-timeline-event-text text-default me-2"></i>
                                Pipeline
                              </span>
                              <i className="ti ti-arrow-right"></i>
                            </Link>
                          </div>
                          <div className="col-sm-6">
                            <Link
                              // to={routes.companiesGrid}
                              to="#"
                              className="d-flex align-items-center justify-content-between p-2 crm-link mb-3"
                            >
                              <span className="d-flex align-items-center me-3">
                                <i className="ti ti-building text-default me-2"></i>
                                Companies
                              </span>
                              <i className="ti ti-arrow-right"></i>
                            </Link>
                            <Link
                              // to={routes.leadsGrid}
                              to="#"
                              className="d-flex align-items-center justify-content-between p-2 crm-link mb-3"
                            >
                              <span className="d-flex align-items-center me-3">
                                <i className="ti ti-user-check text-default me-2"></i>
                                Leads
                              </span>
                              <i className="ti ti-arrow-right"></i>
                            </Link>
                            <Link
                              // to={routes.activity}
                              to="#"
                              className="d-flex align-items-center justify-content-between p-2 crm-link mb-3"
                            >
                              <span className="d-flex align-items-center me-3">
                                <i className="ti ti-activity text-default me-2"></i>
                                Activities
                              </span>
                              <i className="ti ti-arrow-right"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="sidebar sidebar-horizontal"
                id="horizontal-single"
              >
                <div className="sidebar-menu">
                  <div className="main-menu">
                    <ul className="nav-menu">
                      <li className="menu-title">
                        <span>Main</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center"></div>
              <div className="dropdown profile-dropdown">
                <Link
                  to="#"
                  className="dropdown-toggle d-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  <span className="avatar avatar-md online">
                    <ImageWithBasePath
                      src="/assets/img/profilepic.jpg"
                      alt="Img"
                      className="img-fluid rounded-circle"
                    />
                  </span>
                </Link>

                <div className="dropdown-menu shadow-none">
                  <div className="card mb-0">
                    <div className="card-header px-3 py-3">
                      <div className="d-flex align-items-center">
                        <span className="avatar avatar-lg me-3 avatar-rounded border">
                          <ImageWithBasePath
                            src="/assets/img/profilepic.jpg"
                            alt="img"
                            className=" object-fit-contain "
                          />
                        </span>
                        <div>
                          <h5 className="mb-0">Nestfin</h5>
                          {/* <p className="fs-12 fw-medium mb-0">warren@example.com</p> */}
                        </div>
                      </div>
                    </div>
                    {/* <div className="card-body">
                      <Link
                        className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                        // to={routes.profile}
                        to="#"
                      >
                        <i className="ti ti-user-circle me-1"></i>My Profile
                      </Link>
                      <Link
                        className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                        // to={routes.bussinessSettings}
                        to="#"
                      >
                        <i className="ti ti-settings me-1"></i>Settings
                      </Link>
                      <Link
                        className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                        // to={routes.securitysettings}
                        to="#"
                      >
                        <i className="ti ti-status-change me-1"></i>Status
                      </Link>
                      <Link
                        className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                        // to={routes.profilesettings}
                        to="#"
                      >
                        <i className="ti ti-circle-arrow-up me-1"></i>My Account
                      </Link>
                      <Link
                        className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                        // to={routes.knowledgebase}
                        to="#"
                      >
                        <i className="ti ti-question-mark me-1"></i>Knowledge
                        Base
                      </Link>
                    </div> */}
                    <div className="card-footer">
                      {isAuthenticated ? (
                        <div
                          className="dropdown-item d-inline-flex align-items-center p-0 py-0 cursor-pointer"
                          // to={routes.login}
                          onClick={handleLogout}
                        >
                          <i className="ti ti-logout me-2 fs-16"></i>Logout
                        </div>
                      ) : (
                        <Link
                          className="dropdown-item d-inline-flex align-items-center p-0 py-2 cursor-pointer"
                          to={routes.login}
                          // to="#"
                          onClick={handleLogout}
                        >
                          <i className="ti ti-login me-2 fs-16 "></i>Login
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="dropdown mobile-user-menu mt-2 me-2  ">
          <button
            type="button"
            className="btn nav-link dropdown-toggle border-0"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v"></i>
          </button>
          <div className="dropdown-menu dropdown-menu-end">
            <div className="card mb-0">
              <div className="card-header py-3 px-3">
                <div className="d-flex align-items-center">
                  <span className="avatar avatar-lg me-3 avatar-rounded border">
                    <ImageWithBasePath
                      src="/assets/img/profilepic.jpg"
                      alt="img"
                      className=" object-fit-contain "
                    />
                  </span>
                  <div>
                    <h5 className="mb-0">Nestfin</h5>
                  </div>
                </div>
              </div>
              <div className="card-footer p-0 px-3">
                {isAuthenticated ? (
                  <Link
                    className="dropdown-item d-inline-flex align-items-center p-0 cursor-pointer"
                    // to={routes.login}
                    to="#"
                    onClick={handleLogout}
                  >
                    <i className="ti ti-logout me-2 fs-16"></i>Logout
                  </Link>
                ) : (
                  <Link
                    className="dropdown-item d-inline-flex align-items-center p-0 cursor-pointer"
                    to={routes.login}
                    onClick={handleLogout}
                  >
                    <i className="ti ti-login me-2 fs-16"></i>Login
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
      {/* /Header */}
    </>
  );
};

export default Header;
